module.exports = __webpack_public_path__ + "img/roata.b0cc5d2c.svg";